/* SessionDetailsList.tsx generated by @compiled/babel-plugin v3.0.1 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4bt5LAnQyn%7Boverflow-x%3Ahidden%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2WAcuGnQyn%7Boverflow-y%3Ahidden%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2sNsIg7NXe%7Bfont%3Avar(--ds-font-body-small%2Cnormal%20400%209pt%2F1pc%20%22Atlassian%20Sans%22%2Cui-sans-serif%2C-apple-system%2CBlinkMacSystemFont%2C%22Segoe%20UI%22%2CUbuntu%2C%22Helvetica%20Neue%22%2Csans-serif)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4ouGXIdnbC%7Bmin-width%3A0%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1EqgXlN91d%7Bmax-width%3A100%25%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._39xV02N91d%7Bwidth%3A100%25%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0hPCNLDIqT%7Balign-items%3Acenter%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1UtDYzKGUX%7Bcolor%3Avar(--ds-text-subtlest%2C%236b6e76)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3YEZNOdnbC%7Bflex-shrink%3A0%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._20VacPYbGa%7B-webkit-user-select%3Anone%3B-moz-user-select%3Anone%3Buser-select%3Anone%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0GTcwR4F84%7Bmargin-inline-start%3Avar(--ds-space-negative-100%2C-8px)%7D");
import React, { Children, isValidElement, type ReactNode } from 'react';
import { cx } from '@atlaskit/css';
import { Box, Inline } from '@atlaskit/primitives/compiled';
const styles = {
  container: "_4bt5LAnQyn _2WAcuGnQyn _2sNsIg7NXe _4ouGXIdnbC _1EqgXlN91d _39xV02N91d _0hPCNLDIqT _1UtDYzKGUX",
  separator: "_3YEZNOdnbC _20VacPYbGa",
  firstSeparator: "_0GTcwR4F84"
};
export type SessionDetailsListProps = {
  children: ReactNode;
  separator?: ReactNode;
  /** Tightens the first separator when the first detail includes a visible label. */
  compactFirstSeparator?: boolean;
  testId?: string;
};

/** An inline, separator-delimited list of composable session details. */
export const SessionDetailsList = ({
  children,
  separator = '·',
  compactFirstSeparator = false,
  testId
}: SessionDetailsListProps): React.JSX.Element | null => {
  const details = Children.toArray(children).filter(isValidElement);
  if (details.length === 0) {
    return null;
  }
  return <Inline xcss={styles.container} space="space.100" alignBlock="center" testId={testId}>
			{details.map((detail, index) => <React.Fragment key={detail.key ?? index}>
					{index > 0 ? <Box as="span" xcss={cx(styles.separator, compactFirstSeparator && index === 1 && styles.firstSeparator)} aria-hidden="true">
							{separator}
						</Box> : null}
					{detail}
				</React.Fragment>)}
		</Inline>;
};